// An id that CANNOT be resolved returns '' and must be treated as a failure by the caller — never
// passed to an API as `undefined`, which turns a shape problem into a fake "no results".

/* * First key present as a non-empty string, else '' (never undefined — '' is checkable and unsendable). */
export function pickId(o: Record<string, unknown>, keys: string[]): string {
  for (const k of keys) {
    const v = o[k];
    if (typeof v === "string" && v !== "") return v;
  }
  return "";
}

/*
 *
 * Org id from a JD ORG payload. '' means "this org is unusable", not "org zero".
 * Accepts a bare `id` because on an org payload that IS the org.
 */
export function jdOrgIdOf(o: Record<string, unknown>): string {
  return pickId(o, ["jd_org_id", "id", "org_id", "organization_id"]);
}

/*
 *
 * Org id as carried ON A FIELD payload — EXPLICIT keys only, never a bare `id`. `id` is
 * context-dependent and that cuts both ways: on an org payload it means the org, on a field payload
 * it means the FIELD.
 */
export function jdOrgIdOfField(f: Record<string, unknown>): string {
  return pickId(f, ["jd_org_id", "org_id", "organization_id"]);
}

/* * Field id from a JD field payload. '' means unusable. */
export function jdFieldIdOf(f: Record<string, unknown>): string {
  return pickId(f, ["jd_field_id", "id", "field_id"]);
}

/* * Display name, or undefined — callers fall back to the id rather than inventing a name. */
export function jdNameOf(o: Record<string, unknown>): string | undefined {
  const v = o.name ?? o.title ?? o.label;
  return typeof v === "string" && v !== "" ? v : undefined;
}
